import React, { useState, useContext } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/auth"; // useAuth hook from AuthContext
import { toast, ToastContainer } from "react-toastify";
import logo from "../../assets/digitalparag/DigirtalParag.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { api_url } from "../../helpers/apiHelpers";
import loginImage from "../../assets/login.jpg";

const Sign_in = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const [auth, setAuth] = useAuth(); // access auth context
  const navigate = useNavigate(); // to redirect users

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${api_url}/api/auth/signin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.status === 201) {
        toast.success("Logged in successfully!");
        localStorage.setItem("userId", data.user._id);
        localStorage.setItem("userName", data.user.fullName);
        localStorage.setItem("userEmail", data.user.email);
        setTimeout(()=>{
          navigate("/dashboard/dashboard");
        },1000)
      } else {
        toast.error(data.message); // handle error
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div>
      <Header />
      <br /> <br /> <br />
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-2xl  lg:max-w-4xl">
        <div
          className="hidden bg-cover lg:block lg:w-1/2"
          style={{
            backgroundImage: `url(${loginImage})`,
          }}
        ></div>
        <div
          className="w-full px-6 py-3 md:px-8 lg:w-1/2"
          style={{ backgroundColor: "#a3c8e8" }}
        >
          <div className="flex justify-center mx-auto">
            <img className="h-20 w-30 mr-3" src={logo} alt="Logo" />
          </div>
          {/* <p className=" text-xl text-center text-white  ">Welcome back!</p> */}
          <form onSubmit={handleSubmit}>
            <div className="mt-3 text-left">
              <label
                className="block mb-2 text-base font-medium text-dark  "
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg   dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="mt-3">
              <div className="flex justify-between">
                <label
                  className="block mb-2 text-base font-medium text-dark  "
                  htmlFor="password"
                >
                  Password
                </label>
                
              </div>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                  type={showPassword ? "text" : "password"} // Toggle between text and password
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 text-white  "
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <AiFillEyeInvisible size={20} />
                  ) : (
                    <AiFillEye size={20} />
                  )}
                </button>
              </div>
            </div>
            <div className="mt-2 text-end">
                <Link
                  to="/forgot_password"
                  className="text-base text-dark  hover:underline"
                >
                  Forgot Password?
                </Link>
            </div>

            <div className="mt-3 text-center">
              <button
                type="submit"
                className="w-1/2 px-6 py-2 text-base font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
              >
                Sign In
              </button>
            </div>

          </form>

          <div className="flex items-center justify-between mt-4">
            <span className="w-1/5 border-b dark:border-white md:w-1/4"></span>
            <Link
              to="/sign_up"
              className="fw-bold text-base text-dark  uppercase dark:text-gray-400 hover:underline"
            >
              or sign up
            </Link>
            <span className="w-1/5 border-b dark:border-white md:w-1/4"></span>
          </div>
        </div>
      </div>
      <br /> <br /> <br />
      <ToastContainer />
      <Footer />
    </div>
  );
};

export default Sign_in;
